import { render, staticRenderFns } from "./SectionObesity.vue?vue&type=template&id=948efa72&scoped=true&"
import script from "./SectionObesity.vue?vue&type=script&lang=js&"
export * from "./SectionObesity.vue?vue&type=script&lang=js&"
import style0 from "./SectionObesity.vue?vue&type=style&index=0&id=948efa72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948efa72",
  null
  
)

export default component.exports